/**
 * @generated SignedSource<<85ed4edfd9d945bebab55ab846d69566>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionColumn_LandingPageFragment$data = {
  readonly id: string;
  readonly urlParam: string;
  readonly " $fragmentType": "ActionColumn_LandingPageFragment";
};
export type ActionColumn_LandingPageFragment$key = {
  readonly " $data"?: ActionColumn_LandingPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionColumn_LandingPageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionColumn_LandingPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlParam",
      "storageKey": null
    }
  ],
  "type": "LandingPageV2",
  "abstractKey": null
};

(node as any).hash = "77aa4fb95579fe640946303b6243010f";

export default node;
